<div class="sticky-0">
  <h5 class="fw-400">Companies</h5>
  <button class="btn btn-outline-primary right-top-btn" (click)="addCompany()">
    Add Company
  </button>
</div>
<app-shared-table
  [maxCount]="totalCompanies"
  [items]="companies"
  [isType]="'Company'"
  [showButtons]="['edit', 'delete']"
  (itemEdit)="editCompany($event)"
  (itemDelete)="deleteCompany($event)"
  (loadPageData)="loadPageData($event)"
  >
</app-shared-table>

<ng-template #customContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{ submitType }} Company</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d('Cross click'); resetForm()"
    ></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formCompanies">
      <div class="row">
        <div class="col-12">
          <mat-form-field class="example-full-width">
            <mat-label>Name</mat-label>
            <input matInput placeholder="Name" formControlName="name" />
          </mat-form-field>
        </div>
      </div>

      @if (companySections.controls.length > 0) {
        <h6 style="font-weight: 500">
          Sections :
        </h6>
      }

      @for (data of companySections.controls; track data; let i = $index) {
        <ng-container
          class="container border mb-4 p-3 boxed"
          formArrayName="sections"
          >
          @if (i !== 0) {
            <hr />
          }
          <div>
            <div class="row"></div>
            <div class="row">
              <h6 class="pull-left section-number">#{{ i + 1 }}</h6>
              <div class="col-6">
                <mat-form-field
                  class="example-full-width section-text"
                  style="margin: 0 15px"
                  >
                  <mat-label>Name</mat-label>
                  <textarea
                    matInput
                    placeholder="Section Name"
                    [formControl]="companySections.controls[i]"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5"
                    class="textarea-scroll-hide"
                  ></textarea>
                </mat-form-field>
              </div>
              <div class="col-3">
                <button
                  type="button"
                  class="btn btn-raised btn-danger btn-sm btn-action pull-right"
                  (click)="removeSection(i)"
                  >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      }
      <button
        type="button"
        class="btn btn-raised btn-success"
        (click)="addSection()"
        >
        Add Section
      </button>
    </form>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-raised btn-success"
      [disabled]="formCompanies.invalid || !formCompanies.dirty"
      (click)="c('Close click'); submitCompany()"
      >
      {{ submitType }} Company
    </button>

    <button
      type="button"
      class="btn btn-secondary btn-raised"
      (click)="c('Close click'); resetForm()"
      >
      Close
    </button>
  </div>
</ng-template>
